<script>
export default {
  name: "workflowDefaults",
  data() {
    return {
      firstApproverApprovesStage: false,
      defaultProofEmailTemplateId: null,
      defaultNewVersionEmailTemplateId: null,
      working: false,
      loadPromise: null,
    };
  },
  mounted() {
    // Fetch fresh: sessions created before this feature deployed lack the new
    // account field, and the template ids must ride along on save or the
    // update endpoint clears them.
    this.loadPromise = this.loadAccount();
  },
  methods: {
    async loadAccount() {
      const account = await this.$A.AccountService.Get();
      this.firstApproverApprovesStage = _.get(account, "defaultFirstApproverApprovesStage", false);
      this.defaultProofEmailTemplateId = _.get(account, "defaultProofEmailTemplateId", null);
      this.defaultNewVersionEmailTemplateId = _.get(account, "defaultNewVersionEmailTemplateId", null);
    },
    async toggleChanged() {
      if (this.working) return;
      this.working = true;
      // v-model has already flipped the checkbox; capture the intent, then wait
      // for the initial load so the template ids ride along instead of null
      const desired = this.firstApproverApprovesStage;
      await this.loadPromise;
      this.firstApproverApprovesStage = desired;
      const account = await this.$A.AccountService.SetDefaultFirstApproverApprovesStage(
        desired,
        this.defaultProofEmailTemplateId,
        this.defaultNewVersionEmailTemplateId
      );
      this.working = false;
      if (account) {
        this.firstApproverApprovesStage = _.get(account, "defaultFirstApproverApprovesStage", desired);
        _.set(this.$A, "Auth.account.defaultFirstApproverApprovesStage", this.firstApproverApprovesStage);
        this.$A.SaveSessionData(this.$A.Auth);
      } else {
        // Save failed (plan gate, network) — revert so the UI matches the server
        this.firstApproverApprovesStage = !desired;
      }
    },
  },
};
</script>

<template>
  <div class="settings-card">
    <div class="card-head">
      <div class="card-head-title">Workflow Defaults</div>
      <div class="card-head-subtitle">
        Choose the default settings for new workflow stages. You can still
        change these on each stage.
      </div>
    </div>
    <div class="card-body">
      <div class="ashore-toggle default-toggle-row">
        <label class="switch">
          <input
            type="checkbox"
            v-model="firstApproverApprovesStage"
            @change="toggleChanged"
          />
          <span class="slider round"></span>
        </label>
        Approve stage when first approver approves
      </div>
      <small class="default-hint">
        When on, new stages you add to workflows are approved as soon as the
        first approver approves. Existing stages aren't changed.
      </small>
    </div>
  </div>
</template>

<style scoped>
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-weight: 600;
  color: #111827;
}
.card-head-subtitle {
  font-size: 13px;
  color: #6b7280;
}
.card-body {
  padding: 20px;
}
.default-toggle-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #374151;
}
.default-hint {
  display: block;
  margin-top: 8px;
  color: #9ca3af;
}
</style>
